import React from 'react'
import { Modal as AntModal } from 'antd'
import { ModalProps } from './props'

export const Modal: React.FC<ModalProps> = (props) => <AntModal {...props} />
